// Shared between Services.jsx (the vendor list) and ProviderDetail/VendorEdit
// (the full detail/edit pages) so all three agree on the same helpers.

export const initialFor = name => (name || '?').trim().charAt(0).toUpperCase() || '?';

export const mediaUrl = path => `${process.env.REACT_APP_BASE_URL || 'http://localhost:5000'}${path}`;
